<template>
  <div class="product">
    <Portal to="product-slideshow">
      <Transition name="slide-full-right">
        <div v-touch:swipe="handleSwipe" :class="{ 'bg-red-500': !backgroundImage }" class="product-slideshow z-50">
          <div
            v-if="backgroundImage"
            class="z-0 slideshow-background"
            :style="styleObject"
            :class="computedSlideClass"
          />
          <div v-if="backgroundImage" class="slideshow-overlay" />
          <div
            v-for="(slide, index) in slides"
            :key="index"
            class="flex justify-center items-center h-full w-full absolute"
          >
            <transition :name="currentTransition">
              <AppSlide v-if="index === $store.state.activeProductSlide" :key="index">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div v-html="slide" />
              </AppSlide>
            </transition>
          </div>

          <div class="slideshow-nav z-20 absolute w-full">
            <div class="max-w-md mx-auto px-8 flex justify-between items-center">
              <div class="flex flex-1">
                <Transition name="fade">
                  <RouterLink
                    class="btn btn-transparent text-white btn-sm"
                    :to="`/products/${$route.params.id}/config`"
                    data-cy="btn-skip-intro"
                  >
                    <div>skip intro</div>
                  </RouterLink>
                </Transition>
              </div>
              <div v-if="slides.length > 1" class="slideshow-indicators flex-1 flex justify-around">
                <ol class="list-reset pl-0 flex mb-0">
                  <li v-for="(item, index) in slides.length" :key="item.title" class="p-1">
                    <button
                      class="cursor-pointer rounded-full bg-white w-2 h-2"
                      :class="{ active: index === $store.state.activeProductSlide }"
                      @click="handleClickDots(index)"
                    />
                  </li>
                </ol>
              </div>

              <div class="flex-1 text-right">
                <DrButton class="btn-cyan btn-sm px-4 float-right" @click.prevent="handleNextSlideButton">
                  <span class="flex items-center">
                    Next
                    <DrIcon svg="angle-right" scale class="ml-px relative h-4 w-4" style="top: 1px;" />
                  </span>
                </DrButton>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </Portal>
  </div>
</template>

<script>
import AppSlide from '@/components/products/slideshow/Slide.vue'

export default {
  components: {
    AppSlide,
  },
  data () {
    return {
      currentTransition: 'next',
    }
  },
  computed: {
    computedSlideClass () {
      return `app-product-slide-${this.$store.state.activeProductSlide}`
    },
    styleObject () {
      if (this.backgroundImage) {
        return {
          backgroundImage: `url(${this.backgroundImage})`,
          backgroundSize: 'cover',
        }
      }
      return ''
    },
    slides: {
      get () {
        return this.$store.getters.getSlides
      },
      set (value) {
        this.$store.commit(`updateSlides`, value)
      },
    },
    backgroundImage: {
      get () {
        return this.$store.getters.getSlidesBackground
      },
      set (value) {
        this.$store.commit(`updateSlidesBackground`, value)
      },
    },
  },
  destroyed () {
    this.backgroundImage = ''
    this.$store.commit('resetActiveProductSlide')
  },
  methods: {
    nextSlide () {
      this.currentTransition = 'next'
      this.$nextTick(() => {
        this.$store.commit('incrementActiveProductSlide')
      })
    },
    previousSlide () {
      this.currentTransition = 'prev'
      this.$nextTick(() => {
        this.$store.commit('updateActiveProductSlide', this.$store.state.activeProductSlide - 1)
      })
    },
    handleSwipe (event) {
      if (event === 'left' && this.$store.state.activeProductSlide !== this.slides.length - 1) this.nextSlide()
      else if (event === 'right' && this.$store.state.activeProductSlide !== 0) this.previousSlide()
    },
    handleNextSlideButton () {
      if (this.$store.state.activeProductSlide === this.slides.length - 1) {
        this.$router.push(`/products/${this.$route.params.id}/config`)
      } else {
        this.nextSlide()
      }
    },
    handleClickDots (index) {
      if (index > this.$store.state.activeProductSlide) this.currentTransition = 'next'
      else if (index < this.$store.state.activeProductSlide) this.currentTransition = 'prev'
      this.$nextTick(() => {
        this.$store.commit('updateActiveProductSlide', index)
      })
    },
  },
}
</script>

<style scoped>
.slideshow-nav {
  position: absolute;
  bottom: 60px;
}

@media screen and (orientation: landscape) and (max-height: 660px) {
  .slideshow-nav {
    bottom: 10px;
  }
}

/* next/prev transitions */
.next-enter-active,
.next-leave-active,
.prev-enter-active,
.prev-leave-active {
  transition: 0.75s ease;
}

.next-enter,
.next-leave-to,
.prev-enter,
.prev-leave-to {
  opacity: 0;
}

.next-enter,
.prev-leave-to {
  transform: translateX(100%);
}

.next-enter-to,
.next-leave,
.prev-enter-to,
.prev-leave {
  transform: translateX(0);
}

.next-leave-to,
.prev-enter {
  transform: translateX(-100%);
}

.slideshow-indicators button {
  opacity: 0.3;

  @apply text-white;
}

.slideshow-indicators button.active {
  opacity: 1;
}

.product-slideshow {
  overflow: hidden;
}

.slideshow-background {
  width: 200%;
  background-position: 50%;
  transition: all 0.75s;

  @apply h-full absolute top-0 left-0;
}

.slideshow-overlay {
  background: rgba(0, 0, 0, 0.7);

  @apply absolute top-0 left-0 h-full w-full;
}

.app-product-slide-0 {
  transform: translateX(0);
}

.app-product-slide-1 {
  transform: translateX(-15%);
}

.app-product-slide-2 {
  transform: translateX(-30%);
}
</style>
